import { ShieldCheck, BadgeCheck, Timer, DollarSign, Users, ThumbsUp } from "lucide-react";
import { COMPANY } from "@/data/site";

const ITEMS = [
  { icon: ShieldCheck, title: "Fully insured", desc: "Bonded and carrying full liability insurance on every job we do." },
  { icon: Timer, title: "Same-day service", desc: "Most jobs scheduled and completed the same day — no waiting around." },
  { icon: DollarSign, title: "Upfront, flat pricing", desc: "Know the total before we start. No hidden fees, no surprise add-ons." },
  { icon: BadgeCheck, title: "1-year workmanship warranty", desc: "We stand behind every job with a full guarantee in writing." },
  { icon: Users, title: "Family owned & local", desc: "Independent, family-owned and proudly rooted in Roseville and Macomb County." },
  { icon: ThumbsUp, title: "5-star reputation", desc: `${COMPANY.rating}/5 across ${COMPANY.reviewCount}+ verified customer reviews.` },
];

export default function WhyUs() {
  return (
    <section id="why" className="bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="flex items-baseline gap-3">
              <span className="font-display font-black text-sm text-[#A88852]">02 —</span>
              <div className="label-eyebrow">Why us</div>
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900">
              The honest plumber your neighbor told you about.
            </h2>
            <p className="text-slate-600 md:text-lg mt-4 max-w-md">
              Six reasons Macomb County homeowners call us first — and recommend us to friends.
            </p>

            <div className="mt-8 inline-flex items-center gap-4 bg-white border border-slate-200 rounded-md p-4">
              <div className="font-display font-black text-xl text-orange-500 leading-tight">
                Drains cleared. Pipes fixed. Water heaters installed.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {ITEMS.map((it, i) => (
              <div
                key={i}
                data-testid={`why-us-${i}`}
                className="bg-white border border-slate-200 rounded-md p-6"
              >
                <div className="w-10 h-10 bg-orange-500/10 text-orange-600 grid place-items-center rounded-sm mb-4">
                  <it.icon size={20} />
                </div>
                <h3 className="font-display text-lg font-bold text-slate-900 tracking-tight">{it.title}</h3>
                <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{it.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
